// Shared validation regex constants
export const PHONE_REGEX = /^[0-9+\- ]*$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
